<template>
    <div class="d-flex flex-row">
        <b-button class="w-50 sort-btn"
                  :variant="sortingBy===currentKey&&!isDesc?'info':'light'"
                  @click="sort(false)">
            <i class="fa-solid fa-arrow-down-a-z"></i>
            AEC
        </b-button>
        <b-button class="w-50 sort-btn ml-1"
                  :variant="sortingBy===currentKey&&isDesc?'info':'light'"
                  @click="sort(true)">
            <i class="fa-solid fa-arrow-up-z-a"></i>
            DESC
        </b-button>
    </div>
</template>

<script>
export default {
    name: "SortSwitch",
    props: {
        sortingBy: String,
        currentKey: String,
        desc: Boolean,
        direction: String
    },
    computed: {
        isDesc() {
            if (this.direction) {
                return this.direction === 'DESC';
            }
            return this.desc;
        },
    },
    methods: {
        sort(desc) {
            console.log(desc);
            this.$emit('change', desc);
            this.$emit('update:direction', desc ? 'DESC' : 'ASC');
            let same = this.currentKey === this.sortingBy && this.isDesc === desc;
            this.$emit('update:sortingBy', same ? null : this.currentKey);
            this.$emit('update:desc', same ? false : desc);
        },
    }
}
</script>

<style scoped>
.sort-btn {
    min-width: 70px;
}
</style>
